import React from 'react';
import classes from './vision.module.css';
import Title from "../../containers/title/title";
import { getImageUrl } from '../../../utils/imageUrl';

const Vision = ({vision}) => {
    return (
        <div className={classes.Container}>
        <Title title={vision?.title} />
        <div className={classes.DarkEffect} />
        <div className={classes.Background} style={{ backgroundImage: `url(${getImageUrl(vision?.banner_image)})` }}>
            <div>
                <p>{vision?.description}</p>
            </div>
        </div>
    </div>
    )
}
export default Vision;